import Page from 'modules/Page';
import lazyWithSuspense from 'modules/lazyWithSuspense';
import makePage from 'modules/makePage';
import { i18n } from 'i18n';
import useNewRheologyDataQueries, { NewRheologyDataQueries } from '../../../../shared/NewRheologyPage/useNewRheologyDataQueries';
import * as parentConstants from '../../constants';
import * as constants from './constants';
import { NewRheologyPageParams } from './constants';

const NewRheologyPage = lazyWithSuspense(() => import('./NewRheologyPage'));

const page: Page = {
  title: constants.TITLE,
  routeProps: {
    path: constants.ROUTE_PATH,
  },
  admin: false,
  component: makePage<NewRheologyPageParams, NewRheologyDataQueries>({
    WrappedPage: NewRheologyPage,
    titleFn: () => i18n._('New Rheology Data'),
    parentPathTemplate: parentConstants.DETAILS_ROUTE_PATH,
    parentTitleFn: () => i18n._(parentConstants.DETAILS_TITLE),
    pageDataHook: useNewRheologyDataQueries,
  }),
};

export default page;
